<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet class="dialog" rounded>
            <div class="dialog-header">{{ $t("users.new_user") }}</div>
            <div class="dialog-content">
                <v-form ref="form_new_user">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="name"
                                :label="$t('users.name')"
                                dense
                                hide-details="auto"
                                light
                                outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="firstname"
                                :label="$t('users.firstname')"
                                dense
                                hide-details="auto"
                                light
                                outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="email"
                                :label="$t('users.email')"
                                dense
                                hide-details="auto"
                                light
                                outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                v-model="role"
                                :items="visibleRoles()"
                                :label="$t('users.role')"
                                dense
                                hide-details="auto"
                                item-text="name"
                                item-value="id"
                                light
                                outlined
                            >
                                <template #item="{ item,}">
                                    {{ $t(`role.${item}`) }}
                                </template>
                                <template #selection="{ item }">
                                    {{ $t(`role.${item}`) }}
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
            <div class="dialog-footer d-flex">
                <v-btn elevation="0" @click="showDialog = false">
                    {{ $t("global.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" color="primary" elevation="0"
                       @click="createUser">
                    {{ $t("global.validate") }}
                </v-btn
                >
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>

import roles from "../../../mixins/roles";

export default {
    name: "NewUser",
    mixins: [roles],
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            name: "",
            firstname: "",
            email: "",
            role: "",
            loading: false,
            sitesLoading: false,
            sites: [],
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        async createUser() {
            try {
                this.loading = true
                await this.$api.users.create({
                    firstname: this.firstname,
                    lastname: this.name,
                    role: this.role,
                    email: this.email,
                    site_ids: this.sites,

                })
                this.clearInputs()
                this.$emit('close')
                this.loading = false
            } catch (e) {
                this.loading = false
            }
        },
        getSites() {
            try {
                this.sitesLoading = true
                this.$api.sites.all()
                this.sitesLoading = false
            } catch (e) {
                this.sitesLoading = false
            }
        },
        clearInputs() {
            this.firstname = null
            this.name = null
            this.role = null
            this.email = null
            this.sites = null
        }
    }
};
</script>
